import {Impression} from '@/shared/components/dashboard/landing-pages/form/ImpressionSection';
import {Introduction} from '@/shared/components/dashboard/landing-pages/form/IntroductionSection';
import {RoutePlan} from '@/shared/components/dashboard/landing-pages/form/RoutePlanSection';
import {Location} from '@/shared/components/dashboard/landing-pages/form/LocationSection';
import {Accommodation} from '@/shared/components/dashboard/landing-pages/form/AccommodationSection';
import {Activities} from '@/shared/components/dashboard/landing-pages/form/ActivitiesSection';
import {Videos} from '@/shared/components/dashboard/landing-pages/form/Videos';
import {Security} from '@/shared/components/dashboard/landing-pages/form/SecuritySection';

export const COLUMNS_HEADERS = [{id: 'label', key: 'label', label: 'Label'}];

export const RECORDS_PER_PAGE = 20;

export const LANDING_PAGE_ACCORDION_ITEMS = {
  introductionSection: {
    value: 'introductionSection',
    label: '1. Introduction Section',
    Component: Introduction,
  },
  impressionSection: {
    value: 'impressionSection',
    label: '2. Impression Section',
    Component: Impression,
  },
  routePlanSection: {
    value: 'routePlanSection',
    label: '3. Route Plan Section',
    Component: RoutePlan,
  },
  locationSection: {
    value: 'locationSection',
    label: '4. Location Section',
    Component: Location,
  },
  accommodationSection: {
    value: 'accommodationSection',
    label: '5. Accommodation Section',
    Component: Accommodation,
  },
  activitiesSection: {
    value: 'activitiesSection',
    label: '6. Activities Section',
    Component: Activities,
  },
  videosSection: {
    value: 'videosSection',
    label: '7. Videos Section',
    Component: Videos,
  },
  securitySection: {
    value: 'securitySection',
    label: '8. Security Section',
    Component: Security,
  },
};
